<template>
    <div>
        <v-btn
            variant="text"
            height="70"
            width="80"
            @click="squaresClick()"
        >
            <svg-icon :svgData="svgData"/>
        </v-btn>
    </div>
</template>
<script>
    import SvgIcon from '@/components/content/SvgIcon.vue'
    
    export default {
        name: 'SquaresButton',
        components: {
            SvgIcon
        },
        data () {
            return {
                svgData: {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26 26",
                    pathArr: [{
                        d: "M0.5 10.5V0.5H10.5V10.5H0.5ZM3 8H8V3H3V8ZM0.5 25.5V15.5H10.5V25.5H0.5ZM3 23H8V18H3V23ZM15.5 10.5V0.5H25.5V10.5H15.5ZM18 8H23V3H18V8ZM15.5 25.5V15.5H25.5V25.5H15.5ZM18 23H23V18H18V23Z",
                        fill: "#0635AC"
          }]
      }
    }
  },
        methods:{
            squaresClick(){
                this.$emit('squaresClick')
            }
        }
    }
</script>